(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  $("#menu-btn").click(function(){
    $("#menu-btn").toggleClass("show-menu");
    $(".sp-header-nav ul").toggle(1000);
    $(".sp-header-nav").css("height", "auto");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-blend"]) return;
  try {
    
  $(".index-slider-wrap").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 6,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1500, 
        settings: {
        slidesToShow: 5
        }
      },
      {
        breakpoint: 1200,
        settings: {
        slidesToShow: 4
        }
      },
      {
        breakpoint: 980,
        settings: {
        slidesToShow: 3
        }
      }
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-news"]) return;
  try {
    
  $(document).ready(function() {
    $.ajax({
      type: "get",
      url: "https://tokumitsu-coffee.com/feed",
      dataType: "jsonp"
    }).done(function(result) {
      $(result).find("item").each(function(index) {
        var title = $(this).find('title').text();
        var url = $(this).find('link').text();
        var category = $(this).find('category').text();
        var contents = '';

        var pubDate = $(this).find("pubDate").text();
        var Dates = new Date(pubDate);
        var Dday = Dates.getDate();
        var Dmonth = Dates.getMonth() + 1;
        var Dyear = Dates.getFullYear();
        var num = index + 1

        var article = "<a href='" + url + "'" + "class='index-news-list'>" + "<div class='main-news-article'>" + "<time>" + Dyear + Dmonth + Dday + "</time>" + "<span class='news-title link_to'>" + title + "</span>" + "</div></a>"
        $(`#article-${num}`).append(article);

        if (index > 3){
          return false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-single-origin"]) return;
  try {
    
  $(".index-slider-wrap").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 6,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1500, 
        settings: {
        slidesToShow: 5
        }
      },
      {
        breakpoint: 1200,
        settings: {
        slidesToShow: 4
        }
      },
      {
        breakpoint: 980,
        settings: {
        slidesToShow: 3
        }
      }
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
     
  function setDate(){
    for ( var i = 1; i <= 15; i++ ){
      var today = new Date();
      var hours = 24 * i + 24 * 5;
      var setTime = today.setTime(today.getTime() + hours * 3600 * 1000);
      var year = new Date(setTime).getFullYear();
      var mounth = new Date(setTime).getMonth() + 1;
      var date = new Date(setTime).getDate() ;

      var el = "<option value='" + year + "/" + mounth + "/" + date + "'>" + year + "-" + mounth + "-" + date + "</option>";
      console.log(el)

      $("#ship_date").append(el);
    }
  }

  $(window).on("load", function(){
    setDate();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
$(window).on("load",function(){
  var url = location.pathname;
  var btn_wrap = $(`[href='${url}']`).parent();;
  $(btn_wrap).addClass("current-page");

  if(url.match('school')){
    $(".school-note").addClass("school-note-active");
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $("#addCart").click(function(){
      var item_qty = $(".product-addCart-qty > input").val();
      var item_id = $(".product-addCart-container").attr("id");
      var option = $(".type-property select").val();
      var option2 = $(".life-style-property select").val();
      var option3 = [];
      var existence;
      var mamekan1 = $("#mamekan1").val();
      var mamekan2 = $("#mamekan2").val();
      var mamekan3 = $("#mamekan3").val();

      console.log(existence);
      console.log(option3);

      $(".mamekan-property select").each(function(index){
        option3.push($(this).val());
      });
      
      if (option3.length > 0){
        var existence = option3;
      }
      

      var formData = {
        'items': [{
          'id': item_id,
          'quantity': item_qty,
          'properties': {
            '豆or粉': option,
            'ライフスタイルセットの珈琲豆': option2,
            '珈琲豆缶の色': existence
          }
        }]
      };

    if (option == "選択してください" || option2 == "選択してください" || mamekan1 == "選択してください" || mamekan2 == "選択してください" || mamekan3 == "選択してください"){
      var e = [];
      var alertTxt = "";
      if (option == "選択してください" && $('select[name="properties[豆or粉の選択]"]').length){
        e.push("豆or粉の選択を選択してください。");
      };
      if(option2 == "選択してください" && $('select[name="properties[珈琲ライフスタイルセットの珈琲豆]"]').length){
        e.push("ライフスタイルセットの珈琲豆を選択してください。");
      };
      if(mamekan1 == "選択してください" && $('select[name="properties[豆缶の色1]"]').length){
        e.push("珈琲豆缶の色の選択1を選択してください。");
      };
      if(mamekan2 == "選択してください" && $('select[name="properties[豆缶の色2]"]').length){
        e.push("珈琲豆缶の色の選択2を選択してください。");
      };
      if(mamekan3 == "選択してください" && $('select[name="properties[豆缶の色3]"]').length){
        e.push("珈琲豆缶の色の選択3を選択してください。");
      };
      for(var i = 0;i < e.length;i++) {
        alertTxt += e[i] + "\n";
      }
      alert(alertTxt);

    }else{
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        window.location.href ="/cart";
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  });

  $(".product-img img, .product-subimg img").click(function(){
    var img = $(this).attr("src");
    $(".modal-img img").attr("src", img);
    $(".modal-wrap").addClass("show-modal");
  });
  $(".modal-wrap, .close-btn").click(function(){
    $(".modal-wrap").removeClass("show-modal");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommend-item"]) return;
  try {
    
$(window).on("load",function(){
  var url = location.pathname;
  var btn_wrap = $(`[href='${url}']`).parent();;
  $(btn_wrap).addClass("current-page");

  if(url.match('school')){
    $(".school-note").addClass("school-note-active");
  };
});

  } catch(e) { console.error(e); }
})();
})();
